import { Col, Row } from 'react-styled-flexboxgrid';
import { useSwipeable } from 'react-swipeable';

import Box from '../../Global/Atomics/Box'
import { Button } from '../../Global/Atomics/Button';
import { Modal } from '../../Global/Atomics/Modal'
import { Paragraph } from '../../Global/Atomics/Paragraph';

import { useTranslationContext } from '../../../contexts/TranslationContext';
import lockScrollbar from '../../../utils/helpers/lockScrollbar';
import { useGlobalStateContext } from '../../../contexts/GlobalStateContext';
import { useAuthContext } from '../../../contexts/AuthContext';

type TProps = {
    showModal: boolean;
    setShowModal: (value: boolean | ((prevVar: boolean) => boolean)) => void;
}

const LogoutModal = ({ showModal, setShowModal }: TProps) => {
    const { logout } = useAuthContext();
    const { setGlobalState } = useGlobalStateContext();
    const { resources } = useTranslationContext();

    let configs = {
        delta: 30,
        onSwipedDown: () => setShowModal(false),
    }

    const handleLogout = () => {
        setGlobalState({ reset: true });
        logout();
        lockScrollbar(false);
    }

    return (
        <Modal dynamic show={showModal} onClose={() => setShowModal(false)} >
            <Box my="lg" pt="md" mx="md" pr="xs" pl="xs">
                <Row center="xs">
                    {/* Question */}
                    <Col xs={12} {...useSwipeable(configs)}>
                        <Box mb="lg">
                            <Paragraph typography="text-s-bold" customColor="black-1">{resources.label.endSessionQuestion}</Paragraph>
                        </Box>
                    </Col>

                    {/* CTAs */}
                    <Col xs={9} md={6} {...useSwipeable(configs)}>
                        <Box mb="md">
                            <Button size="s" variant="primary-black" width="100%" onClick={handleLogout}>
                                {resources.label.endSession}
                            </Button>
                        </Box>
                        <Box mb="md">
                            <Button size="s" variant="secondary-black" width="100%" onClick={() => setShowModal(false)}>
                                {resources.label.cancel}
                            </Button>
                        </Box>
                    </Col>
                </Row>
            </Box>
        </Modal>
    )
}

export default LogoutModal